import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { useMutation } from '@tanstack/react-query';

import type { Content } from '../global-types/Content';
import { fetchJsonWithTimeout, REQUEST_TIMEOUT } from '../helpers/apiHelper';
import { trackAI } from '../helpers/telemetryHelper';

export function useHandleContentUrl() {
  return useMutation<Content, Error, { url: string; timeout?: number }>({
    mutationFn: ({ url, timeout = REQUEST_TIMEOUT }) =>
      fetchJsonWithTimeout<Content>(url, {
        method: 'POST',
        timeout,
      }),
    onError: (error, { url }) => {
      trackAI(`Request failed for '${url}' with error message: '${error.message}'`, SeverityLevel.Error);
    },
    retry: 0,
  });
}
